module.exports = __webpack_public_path__ + "static/plan-update-category_2-4fd9bd0d0349ec8ce9645ec421614a06.png";